/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  /* Base ":host" styles for the component */
  box-sizing: border-box;
  background-color: var(--calcite-color-foreground-1);
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1);
}
:host * {
  box-sizing: border-box;
}

/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-action-bar-expanded-max-width: When `layout` is `"vertical"`, specifies the component's maximum width.
* @prop --calcite-action-bar-items-space: Specifies the space between slotted components in the component.
*/
:host {
  pointer-events: auto;
  display: inline-flex;
  align-self: stretch;
  gap: var(--calcite-action-bar-items-space, 0);
}

:host([layout=vertical]) {
  flex-direction: column;
}
:host([layout=vertical]):host([overflow-actions-disabled]) {
  overflow-y: auto;
}
:host([layout=vertical]):host([expanded]) {
  max-inline-size: var(--calcite-action-bar-expanded-max-width, auto);
}
:host([layout=vertical]) .action-group--end {
  margin-block-start: auto;
}
:host([layout=vertical]) ::slotted(calcite-action-group:not(:last-of-type)) {
  border-block-end-width: var(--calcite-border-width-sm);
}

:host([layout=horizontal]) {
  flex-direction: row;
}
:host([layout=horizontal]):host([overflow-actions-disabled]) {
  overflow-x: auto;
}
:host([layout=horizontal]) .action-group--end {
  margin-inline-start: auto;
}
:host([layout=horizontal]) ::slotted(calcite-action-group:not(:last-of-type)) {
  border-inline-end-width: var(--calcite-border-width-sm);
}

.action-group--end {
  justify-content: flex-end;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}